module.exports = __webpack_public_path__ + "static/img/scanmp.65a073b7.png";